export default __webpack_public_path__ + "static/media/ID_ANDY_DRAGOYLE_Kawai.3d0384eb.jpg";